'use strict';

import _ from 'lodash';

export default function($timeout) {
  'ngInject';
  var _element = null;

  return {
    controller: function($scope, $http, $sce, $interval, $uibModal) {
      'ngInject';

      $scope.step = 1;
      $scope.email = '';
      $scope.emailError = false;
      $scope.started = false;

      $scope.Submit = function() {
        $scope.started = true;
        if(!validateEmail($scope.email)) {
          $scope.emailError = true;
          return;
        }
        $scope.step++;
        var step1 = _.map(_.filter($scope.element.data.groups[0].items, i => i.selected), i => i.name);
        var step2 = _.map(_.filter($scope.element.data.groups[1].items, i => i.selected), i => i.name);
        $http.post("/api/email/eventcalltoaction", {
          Step1: step1, Step2: step2, Email: $scope.email, Details: $scope.details, Name: $scope.name,
          AudienceSize: $scope.audiencesize,
          TimeAllotted: $scope.timeallotted,
          Other1: $scope.element.data.groups[0].other,
          Other2: $scope.element.data.groups[1].other,
        });
      };

      $scope.$watch('email', function() {
        if($scope.started) {
          $scope.emailError = !validateEmail($scope.email);
        }
      });

      $scope.$watch('step', function() {
        $timeout(function() {
          var maxHeight = Math.max.apply(null, $(_element).find('.selector:visible').map(function() {
            return $(this).height();
          }).get());
          $(_element).find('.selector:visible').height(maxHeight);
        });
      });

      function validateEmail(email) {
        return email.length > 0;
        //var re = /\S+@\S+\.\S+/;
        //return re.test(email);
      }
    },
    link: function(scope, element) {
      _element = element;
    },
    template: require('./eventCallToAction.html')
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/eventcalltoaction.js